import store from "@/store";

export default {
    methods: {
        SaveAsDraft() {
            this.$store
                .dispatch(
                    "prodexpamend/SaveRequestAsDraft",
                    this.isDraft == true ? parseInt(this.id) : null
                )
                .then((res) => {
                    if (res.status == 200) {
                        store.commit("progress/removeProcessing", { root: true });
                        store.dispatch(
                            "progress/setSuccessMessage",
                            `The Amend Production Vendor request has been saved as Draft successfully`
                        );
                        this.$router.push("/VendorRequests");
                    }
                })
                .catch((ex) => {
                    if (ex.response && ex.response.status == 415 && ex.response.data) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error while Saving Amend Production Vendor as Draft. ${ex}`
                        );
                    }
                });
        },
    },
};